/* ============================================================
   TAMWAJ — تقريب أسعار العروض

   خصم بنسبة مئوية يُخرج أرقامًا كسريّة: ١٤٩×٢ ناقص ١٥٪ = ٢٥٣٫٣٠.
   الرقم صحيح حسابيًا لكنه يُقرأ كخطأ، ويُضعف الإحساس بالعرض.

   هنا نقرّب السعر النهائي **نزولًا دائمًا** — فلا تدفع العميلة
   فلسًا فوق ما حسبه الخصم. ٢٥٣٫٣٠ تصير ٢٤٩، و٣٣٥٫٢٥ تصير ٣٢٩.

   الملف مشترك بين ودجت المنتج وسكربت السلة: لو اختلف التقريب
   بينهما لاختلف رقم السلة عن رقم نموذج الطلب أمام العميلة.
   ============================================================ */
(function () {
  var MODES = ['none', 'int', '5', '9', '99'];

  /* المدخل والمخرج بالسنت */
  function round(cents, mode) {
    if (!mode || MODES.indexOf(mode) === -1 || mode === 'none') return Math.round(cents);

    var units = Math.floor(cents / 100);
    if (units <= 0) return Math.round(cents);

    var out;

    if (mode === 'int') {
      out = units;
    } else if (mode === '5') {
      out = Math.floor(units / 5) * 5;
    } else if (mode === '9') {
      /* أكبر عدد ≤ المبلغ ينتهي بـ9 */
      var r = units % 10;
      out = (r === 9) ? units : units - r - 1;
    } else if (mode === '99') {
      out = (units % 100 === 99) ? units : Math.floor((units - 99) / 100) * 100 + 99;
    }

    if (!out || out < 1) out = units;      /* لا ننزل إلى الصفر */
    return out * 100;
  }

  window.TamwajPricing = { round: round };
})();
